export const DEFAULT_BG_COLOR = '#1064ae'; // rgb 16 100 175
export const DEFAULT_CARD_BG_COLOR1 = '#0e5a9d'; // 16 90 159
export const DEFAULT_CARD_BG_COLOR2 = '#116bba'; // 16 107 86
export const DEFAULT_CARD_SHADOW_COLOR1 = '#083257'; // 8 50 87
export const DEFAULT_CARD_SHADOW_COLOR2 = '#1896ff'; // 24 150 266
